module.exports = __webpack_public_path__ + "img/outlook.5c440ee4.png";